<template>
  <div class="home">

    <div >
            <div>
                <section>
                    <div class="py-8 px-8">
                    <div class="d-flex flex-wrap align-items-center justify-content-between">
                        <div class="col-12 col-lg-auto mb-3 mb-lg-0">
                            <div class="d-flex align-items-center">
                                <h4 class="mb-0 me-2">{{$t('invoices')}}</h4>
                            </div>
                        </div>
                        <div class="col-12 col-lg-auto d-flex align-items-center gap-2">
                            <div class="input-group flex-grow-1" style="border-bottom: 1px solid #ddd;">
                                <input class="form-control border-0 search-input" autocomplete="off" type="text" v-model="keyword" :placeholder="$t('search')">
                            </div>
                            <button @click="showFilters = !showFilters" class="btn btn-outline-secondary d-md-none">
                                <AppIcon name="bi-funnel" class="bi bi-funnel" />
                            </button>
                        </div>
                    </div>
                    </div>
                </section>
            </div>
      
            <section class="px-8">
                <invoice-component ref="invoiceComponent" :keyword="keyword" :showFilters="showFilters"></invoice-component>
            </section>
    </div>


  </div>
</template>

<script>
import InvoiceComponent from '../../components/InvoiceComponent.vue'
import helper from '../../helper';

export default {
  name: 'Invoice',
  persistedFilterState: { key: 'invoice-search', fields: ['keyword'] },
  components : {
    InvoiceComponent
  },
  mounted(){
    window.mixpanel.track("invoice");
    //check permissions
    if(helper.checkAccess('view_invoices') == -1) return this.$router.push({path : '/'})
    if(helper.checkAccess('view_invoices') == -2) return this.$router.push({path : '/subscribe'})
    this.triggerCreateFromQuery()
  },
  data(){
    return {
        keyword :'',
        count : 0,
        showFilters: false
    }
  },
  watch: {
    '$route.query.create'() {
      this.triggerCreateFromQuery()
    }
  },
  methods : {
    triggerCreateFromQuery(){
      if (
        this.$route.name !== 'Invoices' ||
        this.$route.query.create !== 'true' ||
        this.$route.query.scanned_data ||
        helper.checkAccess('create_invoices') == -1
      ) {
        return
      }

      this.$nextTick(() => {
        if (this.$refs.invoiceComponent) {
          this.$refs.invoiceComponent.create()
        }
      })
    }
  }
  
}
</script>
